function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "a06692d1-0f64-410f-be52-b30287b917ac",
  x: 35.71,
  y: 106.34,
  width: 33.73,
  height: 29.27,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "fcc2d11c-2801-49fb-95ad-f36d5ec5aa74",
  d: "M68.87 127a17.87 17.87 0 01-30.58-18.5c5.1-8.44 35.71 10.04 30.58 18.5z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "ee0b25d4-9ce5-4f2f-b018-e2a3b9dada1d",
  x: 78.87,
  y: 106.34,
  width: 33.73,
  height: 29.27,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "fcc2d11c-2801-49fb-95ad-f36d5ec5aa74",
  d: "M79.45 127A17.87 17.87 0 00110 108.5c-5.08-8.44-35.66 10.04-30.55 18.5z"
})), /*#__PURE__*/React.createElement("style", null, ".fcc2d11c-2801-49fb-95ad-f36d5ec5aa74{fill:#fff}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M78.25 202.63a10.75 10.75 0 01-1.1-21.45c1.22-.12 2.45-.29 3.66-.5a10.75 10.75 0 013.64 21.19c-1.68.29-3.38.52-5.07.7a10.84 10.84 0 01-1.13.06zm-38-8.39a10.65 10.65 0 01-5.51-1.53 72.57 72.57 0 01-4.29-2.76 10.75 10.75 0 0112.22-17.69c1 .71 2.07 1.38 3.12 2a10.75 10.75 0 01-5.54 20zm77.32-9.71a10.74 10.74 0 01-7.46-18.48 51.2 51.2 0 002.51-2.61 10.75 10.75 0 0116 14.36 69.96 69.96 0 01-3.6 3.72 10.7 10.7 0 01-7.47 3.01zM12.14 161.36a10.76 10.76 0 01-10.06-7c-.62-1.65-1.18-3.33-1.66-5a10.75 10.75 0 0120.66-5.95c.32 1.12.7 2.25 1.12 3.35a10.74 10.74 0 01-10.06 14.55zm126-15.15a10.76 10.76 0 01-10.36-13.64c.35-1.28.72-2.64 1.07-4a10.75 10.75 0 1120.83 5.32c-.39 1.53-.8 3-1.19 4.48a10.76 10.76 0 01-10.38 7.84zm-122-27a10.76 10.76 0 01-9-16.62 54.44 54.44 0 013.23-4.45 10.75 10.75 0 1116.73 13.5c-.68.84-1.33 1.74-1.95 2.68a10.72 10.72 0 01-9.04 4.87zm132.64-15.71a10.74 10.74 0 01-10.25-14c.21-.67.43-1.33.65-2 .27-.84.56-1.68.86-2.51a10.75 10.75 0 0120.27 7.15c-.25.72-.5 1.44-.74 2.15s-.37 1.14-.55 1.71a10.76 10.76 0 01-10.27 7.48zm-94.68-3.31A10.75 10.75 0 0151.46 79c1.3-.33 2.43-.66 3.45-1a10.75 10.75 0 016.86 20.4c-1.53.51-3.17 1-5 1.46a10.59 10.59 0 01-2.67.33zM88.73 74.8a10.63 10.63 0 01-5.09-1.29A10.75 10.75 0 0179.28 59l.13-.23c.5-.9 1-1.88 1.43-2.92a10.75 10.75 0 0119.7 8.62c-.72 1.63-1.49 3.2-2.29 4.66v.07a10.76 10.76 0 01-9.52 5.6zm73.68-13.09a10.8 10.8 0 01-10.66-12.23c.17-1.21.29-2.42.36-3.58a10.75 10.75 0 0121.46 1.35c-.11 1.7-.28 3.44-.53 5.18a10.75 10.75 0 01-10.63 9.28zm-58.49-28.07a10.74 10.74 0 01-9-16.63 46.43 46.43 0 012.57-3.54c.3-.38.62-.75.94-1.12l.12-.14a10.75 10.75 0 0116.16 14.19l-.46.54c-.46.58-.91 1.2-1.33 1.84a10.74 10.74 0 01-9 4.86zm4.73-12.55l.29.25-2.31-2zm38 2.38a10.73 10.73 0 01-5.39-1.47 21.8 21.8 0 00-2.65-1.32 10.75 10.75 0 018.3-19.84 41.8 41.8 0 015.23 2.61 10.75 10.75 0 01-5.45 20z",
  fill: "#52abb9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M106.57 19.38c-.24.27-.47.55-.7.83C96 32.47 96.42 50.12 88.83 63.9c-5.91 10.74-16.37 18.41-27.65 23.23C50.44 91.73 35.41 91.4 26 98c-8.82 6.15-15.17 17.72-16.69 28.12C5 155 29.27 183.32 56.33 190.31c24.77 6.41 53-3.68 68.05-24.34 15.65-21.44 16.57-49.9 25-75.08C153 80.06 158 69.7 160.86 58.65s3.31-23.31-2-33.4a31.84 31.84 0 00-52.26-5.87z",
  fill: "#6fc6dd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "fcc2d11c-2801-49fb-95ad-f36d5ec5aa74",
  d: "M68.87 127a17.87 17.87 0 01-30.58-18.5c5.1-8.44 35.71 10.04 30.58 18.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a06692d1-0f64-410f-be52-b30287b917ac)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 59.64,
  cy: 124.43,
  r: 5.86
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "fcc2d11c-2801-49fb-95ad-f36d5ec5aa74",
  d: "M79.45 127A17.87 17.87 0 00110 108.5c-5.08-8.44-35.66 10.04-30.55 18.5z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ee0b25d4-9ce5-4f2f-b018-e2a3b9dada1d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 88.68,
  cy: 124.43,
  r: 5.86
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "fcc2d11c-2801-49fb-95ad-f36d5ec5aa74",
  d: "M39.7 166.63c-3-2.19-6.05-11.34-1.21-15.23s12.8 1.38 14.31 4.74M56.48 154.39c-1.66-3.28-.69-12.69 5.11-14s10.65 6.83 10.57 10.51M76.16 150.9c-.08-3.68 4.75-11.78 10.56-10.51s6.77 10.71 5.12 14M95.52 156.14c1.5-3.36 9.43-8.58 14.3-4.74s1.75 13-1.2 15.23"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M39.57 168.16a44.61 44.61 0 0169.17 0",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: "3.8px"
});

function SvgBacteria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e92be143-f478-4acc-acf7-9b50f690f258",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.59 202.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacteria);
export default __webpack_public_path__ + "static/media/bacteria.a386c92d.svg";
export { ForwardRef as ReactComponent };